/**
 * Quiet "update ready" markers for the web app (docs/web-updates, concept D):
 * a dot on the home Settings button and a Refresh row in the Settings hub.
 * They show whenever a newer build is live, including during your turn, when
 * the toast (WebUpdateToast) waits.
 */
import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { refreshToLatest, useWebUpdate } from '../../lib/webUpdate'

/** Red dot for the Settings button while an update is waiting. */
export function WebUpdateDot() {
  const { updateReady } = useWebUpdate()
  if (!updateReady) return null
  return <View testID="web-update-dot" accessibilityLabel="Update ready"
    className="bg-blood rounded-full border-2 border-paper" style={{ width: 11, height: 11 }} />
}

/** "Update ready · Refresh" row for the Settings hub. */
export function WebUpdateRow() {
  const { updateReady } = useWebUpdate()
  if (!updateReady) return null
  return (
    <View testID="settings-web-update" className="bg-paper-up border border-olive rounded-xl px-4 py-3 flex-row items-center gap-3">
      <View className="bg-blood rounded-full" style={{ width: 9, height: 9 }} />
      <Text className="flex-1 text-ink font-typed" style={{ fontSize: 15 }}>A new build is ready.</Text>
      <TouchableOpacity testID="settings-web-update-refresh" accessibilityRole="button" accessibilityLabel="Refresh to update"
        onPress={() => refreshToLatest()} className="bg-blood rounded-lg px-3 py-2">
        <Text className="text-paper font-stencil uppercase" style={{ fontSize: 11, letterSpacing: 0.6 }}>Refresh</Text>
      </TouchableOpacity>
    </View>
  )
}
